/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface XeroInvoice
 */
export interface XeroInvoice {
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  invoiceId: string;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  invoiceNumber: string;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  reference: string;
  /**
   *
   * @type {number}
   * @memberof XeroInvoice
   */
  amountDue: number;
  /**
   *
   * @type {number}
   * @memberof XeroInvoice
   */
  amountCredited: number;
  /**
   *
   * @type {number}
   * @memberof XeroInvoice
   */
  amountPaid: number;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  currencyCode: string;
  /**
   *
   * @type {number}
   * @memberof XeroInvoice
   */
  currencyRate: number;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  type: string;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  contactName: string;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  date: string;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  dueDate: string;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  url: string;
  /**
   *
   * @type {string}
   * @memberof XeroInvoice
   */
  status: string;
}

/**
 * Check if a given object implements the XeroInvoice interface.
 */
export function instanceOfXeroInvoice(value: object): value is XeroInvoice {
  if (!("invoiceId" in value) || value["invoiceId"] === undefined) return false;
  if (!("invoiceNumber" in value) || value["invoiceNumber"] === undefined)
    return false;
  if (!("reference" in value) || value["reference"] === undefined) return false;
  if (!("amountDue" in value) || value["amountDue"] === undefined) return false;
  if (!("amountCredited" in value) || value["amountCredited"] === undefined)
    return false;
  if (!("amountPaid" in value) || value["amountPaid"] === undefined)
    return false;
  if (!("currencyCode" in value) || value["currencyCode"] === undefined)
    return false;
  if (!("currencyRate" in value) || value["currencyRate"] === undefined)
    return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("contactName" in value) || value["contactName"] === undefined)
    return false;
  if (!("date" in value) || value["date"] === undefined) return false;
  if (!("dueDate" in value) || value["dueDate"] === undefined) return false;
  if (!("url" in value) || value["url"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function XeroInvoiceFromJSON(json: any): XeroInvoice {
  return XeroInvoiceFromJSONTyped(json, false);
}

export function XeroInvoiceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): XeroInvoice {
  if (json == null) {
    return json;
  }
  return {
    invoiceId: json["invoiceId"],
    invoiceNumber: json["invoiceNumber"],
    reference: json["reference"],
    amountDue: json["amountDue"],
    amountCredited: json["amountCredited"],
    amountPaid: json["amountPaid"],
    currencyCode: json["currencyCode"],
    currencyRate: json["currencyRate"],
    type: json["type"],
    contactName: json["contactName"],
    date: json["date"],
    dueDate: json["dueDate"],
    url: json["url"],
    status: json["status"],
  };
}

export function XeroInvoiceToJSON(json: any): XeroInvoice {
  return XeroInvoiceToJSONTyped(json, false);
}

export function XeroInvoiceToJSONTyped(
  value?: XeroInvoice | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    invoiceId: value["invoiceId"],
    invoiceNumber: value["invoiceNumber"],
    reference: value["reference"],
    amountDue: value["amountDue"],
    amountCredited: value["amountCredited"],
    amountPaid: value["amountPaid"],
    currencyCode: value["currencyCode"],
    currencyRate: value["currencyRate"],
    type: value["type"],
    contactName: value["contactName"],
    date: value["date"],
    dueDate: value["dueDate"],
    url: value["url"],
    status: value["status"],
  };
}
